export const State = Object.freeze({
  ACT: 'ACT',
  NSW: 'NSW',
  NT: 'NT',
  QLD: 'QLD',
  SA: 'SA',
  TAS: 'TAS',
  VIC: 'VIC',
  WA: 'WA',
});

export const StateCodes = Object.freeze([
  { code: 1, value: State.ACT },
  { code: 2, value: State.NSW },
  { code: 3, value: State.NT },
  { code: 4, value: State.QLD },
  { code: 5, value: State.SA },
  { code: 6, value: State.TAS },
  { code: 7, value: State.VIC },
  { code: 8, value: State.WA },
]);
